<template>
    <div>
        <v-row class="ma-16 text-center">
          <v-col cols="12">
            <p class="text-h1">Już wkrótce...</p>
          </v-col>
        </v-row>
        <v-row class="ma-16 text-center">
          <v-col cols="12">
            <v-btn color="primary" @click="$router.push('/sklep')">Powrót do sklepu</v-btn>
          </v-col>
        </v-row>
    </div>
</template>